var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2533 41.3218C19.052 41.252 18.8387 41.2229 18.626 41.2363C18.4133 41.2497 18.2054 41.3053 18.0144 41.3999C17.8234 41.4945 17.6532 41.6261 17.5136 41.7872C17.3741 41.9483 17.268 42.1355 17.2015 42.338C15.8625 46.3398 11.5357 47.5792 9.0375 47.9648C9.42317 45.4667 10.6625 41.1398 14.6622 39.7987C14.8808 39.7452 15.086 39.6468 15.2647 39.5099C15.4433 39.3729 15.5916 39.2003 15.7 39.0031C15.8085 38.8058 15.8747 38.5881 15.8947 38.3639C15.9146 38.1397 15.8877 37.9138 15.8157 37.7005C15.7437 37.4872 15.6281 37.2912 15.4764 37.1249C15.3247 36.9586 15.14 36.8257 14.9342 36.7345C14.7284 36.6433 14.5059 36.5959 14.2808 36.5952C14.0556 36.5946 13.8328 36.6407 13.6265 36.7307C10.2963 37.8292 7.85883 40.4682 6.55883 44.3487C5.98295 46.094 5.66827 47.9149 5.625 49.7523C5.625 50.1833 5.7962 50.5966 6.10095 50.9014C6.4057 51.2061 6.81902 51.3773 7.25 51.3773C9.08666 51.3338 10.9068 51.0191 12.6515 50.4435C16.532 49.1435 19.1732 46.706 20.2695 43.3737C20.3397 43.1723 20.369 42.959 20.3557 42.7462C20.3425 42.5334 20.2869 42.3254 20.1923 42.1344C20.0977 41.9433 19.9659 41.773 19.8047 41.6335C19.6434 41.494 19.456 41.388 19.2533 41.3218Z",
    fill: "url(#paint0_linear_239_301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8621 13.8616C45.7671 13.1734 45.4498 12.5351 44.9585 12.0438C44.4673 11.5526 43.829 11.2353 43.1408 11.1403C40.8441 10.7936 34.8944 10.6333 29.0856 16.4421L27.2569 18.2491H14.8051C13.9442 18.2558 13.12 18.5987 12.5084 19.2046L5.95209 25.787C5.53618 26.2005 5.24078 26.7195 5.09763 27.2883C4.95448 27.8571 4.96899 28.4541 5.13959 29.0153C5.30905 29.5803 5.62907 30.0885 6.06534 30.4854C6.50161 30.8824 7.03768 31.1531 7.61609 31.2686L15.6393 32.8741L24.1326 41.3675L25.7359 49.3885C25.8511 49.9673 26.1217 50.5038 26.5186 50.9405C26.9156 51.3771 27.424 51.6975 27.9893 51.8671C28.2926 51.9646 28.6068 52.0123 28.9253 52.0101C29.3526 52.0144 29.7764 51.9321 30.1711 51.7682C30.5657 51.6044 30.9232 51.3624 31.2219 51.0568L37.8021 44.4918C38.4087 43.8826 38.7512 43.0591 38.7554 42.1995V29.7476L40.5646 27.919C46.3713 22.1101 46.2088 16.1583 45.8621 13.8616ZM14.8051 21.4991H24.0069L15.9036 29.6046L8.24442 28.0815L14.8051 21.4991ZM35.5033 42.1995L28.9231 48.7601L27.3999 41.101L35.5033 32.9976V42.1995Z",
    fill: "url(#paint1_linear_239_301)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_301",
    x1: 12.9919,
    y1: 36.5952,
    x2: 12.9919,
    y2: 51.3773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69F6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B44654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_239_301",
    x1: 25.5023,
    y1: 11,
    x2: 25.5023,
    y2: 52.0103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69F6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B44654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332044"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaning);
export default __webpack_public_path__ + "static/media/planing.7bc834936f252c657f9f09b6c0506ac1.svg";
export { ForwardRef as ReactComponent };